
(function($, window){

    // On document ready
    $(function(){   
    });

    // Nav
    
    $('#nav-reveal').click(function(e){
        e.preventDefault();
        $('body').toggleClass('nav-out');
    });

    $('#modal-nav-mask').click((e) => {
        e.preventDefault();
        $('body').removeClass('nav-out');
    });

    $('#main-navigation').find('a').click((e) => {
        $('body').removeClass('nav-out');
    });

    $('.to-top').click(function(e) {
        e.preventDefault();
        gsap.to(window, {
            duration: 0.3, 
            scrollTo: 0,
            ease: "power3.out"
        });
    });

    let modalMask = $('#modal-mask');
    $('#site-logo').hover(function(){
        modalMask.addClass('show');
    }, function(){
        modalMask.removeClass('show');
    });

    $('.mini-hero .button').hover(function(){
        $(this).closest('.mini-hero').addClass('show');
    }, function(){
        $(this).closest('.mini-hero').removeClass('show');
    });

})(jQuery, window);
